import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerType } from '../../../interfaces/common/customer';
import { ILocation } from '../../../interfaces/common/location';
import { displayLocation } from '../../../utils/locations';
import { Alert } from '@mui/material';

interface CustomerWithNavigateProps {
  customer: CustomerType | null;
  location?: ILocation | null;
}

function CustomerWithNavigate({
  customer,
  location,
}: CustomerWithNavigateProps) {
  const navigate = useNavigate();
  return customer == null ? (
    <Alert severity="error">Not Found</Alert>
  ) : (
    <div
      style={{ cursor: 'pointer' }}
      onClick={() => {
        navigate(`/customer/${customer.id}`);
      }}
    >
      <b>{customer.name == '' ? 'No Name' : customer.name}</b>
      <br />
      {location && displayLocation(location)}
    </div>
  );
}

export default CustomerWithNavigate;
